import React from 'react';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { WarningThumbnail } from '@ukpostbox/frontend-framework';
import { MailItemLockedThumbnailType } from '../Types/ThumbnailTypes';

function MailItemLockedThumbnail(props: MailItemLockedThumbnailType) {
	return <WarningThumbnail icon={faLock} size={props.size} />;
}

export { MailItemLockedThumbnail };
